const langSwitcher = document.querySelector('#lang-menu__list')
const langButton = langSwitcher.querySelector('.pll-parent-menu-item > a')
const langSubmenu = langSwitcher.querySelector('.sub-menu')

langButton.addEventListener('click', (e) => {
    e.preventDefault()
    langSubmenu.classList.toggle('is-active')
})

document.addEventListener('click', (e) => {
    if (!langSwitcher.contains(e.target)) {
        langSubmenu.classList.remove('is-active')
    }
})
